import { titleCase } from 'title-case';

// Stand-in words that put a fragment in the middle of a title, so the rules
// for a title's first and last word (always capitalized) don't apply to it.
const LEAD = 'a ';
const TAIL = ' a';

/**
 * Turns a sentence-case label into English title case: every word is
 * capitalized except short articles, conjunctions and prepositions ("Back to
 * Topic", "Share in Messaging App"). Words are only ever capitalized, never
 * lowercased, so proper nouns and acronyms ("Snowball", "SMS", "iOS") survive.
 *
 * The rules can't tell a verb particle from a preposition mid-label: "set up
 * the rest" becomes "Set up the Rest". Such labels supply their own title
 * case (see `SmartCaseButton`'s `titleCase` prop).
 *
 * `position` places `label` inside a longer title assembled from fragments:
 * a fragment that doesn't open the title doesn't get its first word
 * capitalized for that reason, and likewise for one that doesn't close it.
 */
const toTitleCase = (
  label: string,
  position: { first: boolean; last: boolean } = { first: true, last: true }
): string => {
  const lead = position.first ? '' : LEAD;
  const tail = position.last ? '' : TAIL;
  const cased = titleCase(`${lead}${label}${tail}`);
  return cased.slice(lead.length, cased.length - tail.length);
};

/**
 * The casing a footer button label takes in the current Ionic mode. Labels
 * are written in sentence case: md mode shows them as written, ios mode in
 * title case, per each platform's convention. (Material's button styles may
 * still uppercase the result in CSS.)
 */
const smartCase = (label: string, isIonModeIOS: boolean): string =>
  isIonModeIOS ? toTitleCase(label) : label;

export const FooterLogic = {
  toTitleCase,
  smartCase,
};
